import { RADIUS, TEXT_MUTED, OPAQUE_PANEL_BG, GOLD_TEXT } from '../../lib/medievalTheme';
import { getClass } from '../../utils/arena/classes';
import { ferocityProgress } from '../../utils/arena/battlemage';
import { t } from '../../localization/t';
import { VialGauge } from './ForesightGauge';

const CLS = getClass('battlemage');
const ACCENT = CLS.accent;

// Ferocity during the match: the vial, banked plus what this match has
// dealt so far, read from the mirror's `stats`. Sits at the top edge of
// the board where the Oracle's omen sits.
export default function FerocityProgress({ standing, stats, seat, skillState }) {
  const { gained, flawless } = ferocityProgress(stats, seat, skillState);
  const max = standing.ferocityMax;
  const value = Math.min(max, standing.ferocity + gained);
  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[999]" data-testid="ferocity-progress">
      <div
        className="flex items-center"
        style={{
          gap: '0.625cqw', padding: '0.3125cqw 0.875cqw 0.3125cqw 0.5cqw', width: '15cqw',
          borderRadius: RADIUS.md, backgroundColor: OPAQUE_PANEL_BG,
          boxShadow: `0 0 0 1px ${GOLD_TEXT} 0.45), 0 0.25cqw 0.75cqw rgba(0,0,0,0.6)`,
        }}
      >
        <div className="relative shrink-0" style={{ width: '1.75cqw', height: '1.75cqw' }}>
          <span aria-hidden className="vh-skill-capstone-ornament" style={{ '--vh-capstone-ornament-svg': `url("${CLS.majorOrnament}")`, '--vh-capstone-ornament-color': ACCENT }} />
        </div>
        <div className="flex flex-col flex-1 min-w-0" style={{ gap: '0.25cqw' }}>
          <div className="flex items-baseline justify-between" style={{ gap: '0.5cqw' }}>
            <span className="arena-heading truncate" style={{ color: ACCENT, fontSize: '0.8125cqw', letterSpacing: '0.04em' }}>{t('Ferocity')}</span>
            <span className="arena-heading tabular-nums" style={{ color: gained > 0 ? '#ffd9d3' : TEXT_MUTED, fontSize: '0.6875cqw' }}>
              {flawless ? t('+{n}, untouched', { n: gained }) : `+${gained}`}
            </span>
          </div>
          <VialGauge value={value} max={max} color={ACCENT} height={0.625} notch={10} />
        </div>
      </div>
    </div>
  );
}
